import { render, staticRenderFns } from "./addStoreAds.vue?vue&type=template&id=505f9685"
import script from "./addStoreAds.vue?vue&type=script&lang=js"
export * from "./addStoreAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports